// @flow
import React, { type Node } from 'react';
import { IndexRoute, Route } from 'react-router';
import { OfficeNotFoundView } from 'angieslist-app-platform/lib/browser';
import App from '../../../app/browser/App';
import './homeIon.scss';
import WelcomeView from './WelcomeView';
import BusinessView from './BusinessView';
import WelcomeDownloadView from './WelcomeDownloadView';
import PerformanceView from './PerformanceView';
import FAQView from './FAQView';
import CallLog from './CallLog';
import BusinessListFeatureFlaggedPage from './BusinessListFeatureFlaggedPage';

export default function createRoutes(): Node {
  return (
    <Route component={App} path="/">
      <IndexRoute component={BusinessListFeatureFlaggedPage} />
      <Route component={BusinessListFeatureFlaggedPage} path="/home" />
      <Route component={BusinessListFeatureFlaggedPage} path="/app/home" />
      <Route component={BusinessView} path="/app/home/:serviceProviderId" />
      <Route component={PerformanceView} path="/app/performance/:serviceProviderId" />
      <Route component={FAQView} path="/app/performanceFAQ/:serviceProviderId" />
      <Route component={WelcomeView} path="/app/welcome/:serviceProviderId" />
      <Route component={WelcomeDownloadView} path="/app/welcome/:serviceProviderId/download-app" />
      <Route component={CallLog} path="/app/callLog/:serviceProviderId" />
      <Route component={OfficeNotFoundView} path="*" />
    </Route>
  );
}



// WEBPACK FOOTER //
// ./src/modules/home/browser/createRoutes.js